export default function PageHeader({ eyebrow, title, children, className = "" }) {
  return (
    <div className={`flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between mb-6 lg:mb-8 ${className}`.trim()}>
      <div className="min-w-0 flex-1">
        {eyebrow && <div className="page-eyebrow truncate">{eyebrow}</div>}
        <h1 className="page-title break-words">{title}</h1>
      </div>
      {children && (
        <div className="flex flex-col gap-3 w-full lg:w-auto lg:flex-row lg:flex-wrap lg:items-center lg:justify-end shrink-0 min-w-0">
          {children}
        </div>
      )}
    </div>
  );
}
